import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ListReward from "../Components/Reward Voucher/listReward";
import EditReward from "../Components/Reward Voucher/editReward";
import ListRewardPoints from "../Components/Reward Point/listReward";
import ListUserRewards from "../Components/Reward User/listReward";
import ListDoneUserRewards from "../Components/Reward User Done/listDoneReward";
import ViewDoneUserRewards from "../Components/Reward User Done/viewDoneReward";
import ViewUserRewards from "../Components/Reward User/viewReward";
import SignupListReferrals from "../Components/Referrals/signupReferral";
import RewardsHeaderList from "../Components/Rewards/rewardsHeader";
import ViewRewards from "../Components/Reward Voucher/viewReward";
import AddRewards from "../Components/Reward Voucher/addReward";
import AddRewardPoints from "../Components/Reward Point/addReward";
import UpdateRewardPoints from "../Components/Reward Point/editReward";

const RewardsRoutes = () => {

  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  return (
    <Routes>
      <Route
        path="/rewards"
        element={<RewardsHeaderList></RewardsHeaderList>}
      ></Route>
      <Route
        path="/list_voucher_rewards"
        element={<ListReward></ListReward>}
      ></Route>
      <Route
        path="/rewards_voucher/edit/:id"
        element={canEdit ? <EditReward /> : <Navigate to="/rewards" replace />}
      ></Route>
      <Route
        path="/list_point_rewards"
        element={<ListRewardPoints></ListRewardPoints>}
      ></Route>
      <Route
        path="/list_user_rewards"
        element={<ListUserRewards></ListUserRewards>}
      ></Route>
      <Route
        path="/list_done_user_rewards"
        element={<ListDoneUserRewards></ListDoneUserRewards>}
      ></Route>
      <Route
        path="/signup_referrals"
        element={<SignupListReferrals></SignupListReferrals>}
      ></Route>
      <Route
        path="/rewards_voucher/view/:id"
        element={<ViewRewards></ViewRewards>}
      ></Route>
      <Route
        path="/rewards_voucher/add"
        element={<AddRewards></AddRewards>}
      ></Route>

      <Route
        path="/rewards_point/add"
        element={canAdd ? <AddRewardPoints /> : <Navigate to="/rewards" replace />}
      ></Route>
      <Route
        path="/rewards_point/edit/:id"
        element={canEdit ? <UpdateRewardPoints /> : <Navigate to="/rewards" replace />}
      ></Route>


      <Route
        path="/rewards_user_point/view/:id"
        element={<ViewUserRewards></ViewUserRewards>}
      ></Route>

      <Route
        path="/done_user_rewards/view/:id"
        element={<ViewDoneUserRewards></ViewDoneUserRewards>}
      ></Route>


    </Routes>
  );
};

export default RewardsRoutes;
